<template>
  <svg viewBox="0 0 478 478" :class="$style['mark']" aria-hidden="true" focusable="false">
    <path :class="$style['mark__back']" d="M330.269 76.1986C355.02 168.778 343.244 416.977 253.323 441.126C163.401 465.275 29.3852 256.23 4.63486 163.65C-20.1155 71.0708 72.3758 124.792 162.297 100.643C252.219 76.4936 305.519 -16.381 330.269 76.1986Z" />
    <path d="M473.965 163.724C449.083 256.797 312.357 466.421 219.495 441.482C126.633 416.543 112.799 166.486 137.682 73.4126C162.564 -19.6606 218.143 74.245 311.006 99.1839C403.868 124.123 498.847 70.6511 473.965 163.724Z" />
  </svg>
</template>
<style module>
/* The two petals of the logo, in the current text color */
.mark {
  display: inline-block;
  width: 0.9em;
  height: 0.9em;
  flex: none;
  fill: currentcolor;
}

.mark__back {
  opacity: 0.55;
}
</style>
